import { useMutation, useQueryClient } from "react-query";
import { useContext } from "react";
import { FetchContext } from "../context/FetchContext";

export const useCreateProject = () => {
  const queryClient = useQueryClient();
  const fetchContext = useContext(FetchContext);

  return useMutation(
    async (project) => {
      await fetchContext.authAxios.post(`/projects`, project);
    },
    {
      onMutate: async (project) => {
        await queryClient.cancelQueries("projects");
        const previous = queryClient.getQueryData("projects");

        queryClient.setQueryData("projects", (old) => [...old, project]);
        return { previous };
      },
      onError: (err, newTodo, context) => {
        queryClient.setQueryData("projects", context.previous);
      },
      onSettled: () => {
        queryClient.invalidateQueries("projects");
      },
    }
  );
};
